import { render, staticRenderFns } from "./BotaoIconeBase.vue?vue&type=template&id=2f7c787f&scoped=true"
import script from "./BotaoIconeBase.vue?vue&type=script&setup=true&lang=js"
export * from "./BotaoIconeBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BotaoIconeBase.vue?vue&type=style&index=0&id=2f7c787f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7c787f",
  null
  
)

export default component.exports